import { Button, Menu, MenuButton, MenuItem, MenuList, Portal, Spinner } from '@chakra-ui/react'
import { ChevronDown } from 'lucide-react'

export type ExportFormat = 'csv' | 'excel' | 'pdf'

type Props = {
  onClick?: (format: ExportFormat) => void
  isDisabled?: boolean
  isLoading?: boolean
}


export function ExportButton({ onClick, isDisabled, isLoading }: Props) {
  const exportOptions: { label: string; value: ExportFormat }[] = [
    { label: 'CSV', value: 'csv' },
    { label: 'Excel', value: 'excel' },
    { label: 'PDF', value: 'pdf' },
  ]

  return (
    <Menu placement="bottom-end" isLazy closeOnSelect={false} strategy="fixed">
      <MenuButton
        as={Button}
        size="sm"
        variant="outline"
        rightIcon={isLoading ? <Spinner size="sm" /> : <ChevronDown size={16} />}
        px={4}
        isDisabled={isDisabled || isLoading}
      >
        Export
      </MenuButton>

      <Portal>
        <MenuList minW="160px" zIndex={2000}>
          {exportOptions.map((option) => (
            <MenuItem key={option.value} onClick={() => void onClick?.(option.value)}>
              {option.label}
            </MenuItem>
          ))}
        </MenuList>
      </Portal>
    </Menu>
  )
}
